import React from 'react';
import styles from './Address.module.scss';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import { getRenderControl } from '../../../../../../components/SingleControlCustom/getRenderControl';
import { useDispatch, useSelector } from 'react-redux';
import {
  applyFlats,
  applyHouse,
  applyStreet,
} from '../../../../store/actions/documentFilterNew.actions';

const Address = ({
  optionStreet = [],
  optionHouse = [],
  optionsFlat = [],
  isStreetFetching,
  isHouseFetching,
  isFlatFetching,
}) => {
  const { streetId, houseId, flatIds } = useSelector(
    (state) => state.documentFilterNewStore
  );

  const dispatch = useDispatch();

  const handleChangeStreet = (value) => {
    dispatch(applyStreet(value));
  };

  const handleChangeHouse = (value) => {
    dispatch(applyHouse(value));
  };

  const handleChangeFlats = (value) => {
    dispatch(applyFlats(value));
  };

  return (
    <div>
      <Form.Item
        label="Улица"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={streetId}
          onChange={handleChangeStreet}
          multiple={false}
          options={optionStreet}
          renderControl={getRenderControl({
            options: optionStreet,
            isClear: true,
            onClearClick: () => {
              handleChangeStreet(null);
            },
            value: streetId,
            placeholder: 'Выберите из списка',
            disabled: isStreetFetching,
            loading: isStreetFetching,
          })}
        />
      </Form.Item>
      <div className={styles.content}>
        <Form.Item
          label="Дом"
          className={styles.itemForContent}
        >
          <DropdownSelect
            value={houseId}
            onChange={handleChangeHouse}
            multiple={false}
            options={optionHouse}
            renderControl={getRenderControl({
              options: optionHouse,
              isClear: true,
              onClearClick: () => {
                handleChangeHouse(null);
              },
              value: houseId,
              placeholder: '№',
              disabled: isHouseFetching,
              loading: isHouseFetching,
            })}
          />
        </Form.Item>
        <Form.Item
          label="Кв./офис"
          className={styles.itemForContent}
        >
          <DropdownSelect
            value={flatIds}
            onChange={handleChangeFlats}
            disabled={isFlatFetching}
            loading={isFlatFetching}
            multiple={true}
            options={optionsFlat}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default Address;
